import { Component, OnDestroy, ViewChild, inject, signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ApiPaginationResult,
  PaginationResult,
} from '../../../../shared/models/api-result.model';
import { Parameter } from '../../../models/parameter.model';
import { ParameterService } from '../../../services/parameter.service';
import { MessageService } from 'primeng/api';
import { Table, TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { RouterLink } from '@angular/router';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { PaginationService } from '../../../../shared/services/pagination.service';

@Component({
  selector: 'app-parameter-list',
  imports: [
    FormsModule,
    InputTextModule,
    TableModule,
    BreadcrumbModule,
    ToolbarModule,
    ButtonModule,
    RouterLink,
    ProgressSpinnerModule,
    ToastModule,
  ],
  templateUrl: './parameter-list.component.html',
})
export class ParameterListComponent implements OnDestroy {
  @ViewChild('table') table?: Table;

  private parameterService = inject(ParameterService);
  private messageService = inject(MessageService);
  paginationService = inject(PaginationService);

  parameters = signal<Parameter[]>([]);

  pageNumber = signal(1);
  pageSize = signal(10);
  totalRecords = signal(0);
  totalPages = signal(0);

  loading = signal(false);

  keyFilter?: string;
  valueFilter?: string;

  private destroyFilter$ = new Subject<void>();
  private filterChanged$ = new Subject<void>();

  constructor() {
    this.filterChanged$
      .pipe(debounceTime(500), takeUntil(this.destroyFilter$))
      .subscribe(() => {
        this.pageNumber.set(0);
        this.table?.reset();
      });
  }

  ngOnDestroy(): void {
    this.destroyFilter$.next();
    this.destroyFilter$.complete();
  }

  onFilterChange(): void {
    this.filterChanged$.next();
  }

  loadData(event: any): void {
    const page = this.paginationService.mapLazyEventToPageRequest(
      event,
      this.pageSize()
    );
    this.pageNumber.set(page.pageNumber);
    this.pageSize.set(page.pageSize);

    this.loading.set(true);

    this.parameterService
      .getAll(
        this.pageNumber(),
        this.pageSize(),
        this.keyFilter,
        this.valueFilter
      )
      .subscribe({
        next: (response: ApiPaginationResult) => {
          this.loading.set(false);

          const page = response.data as PaginationResult;
          this.parameters.set(page.items as Parameter[]);
          this.pageNumber.set(page.pageNumber);
          this.pageSize.set(page.pageSize);
          this.totalRecords.set(page.totalCount);
          this.totalPages.set(page.totalPages);
        },
        error: (e) => {
          this.loading.set(false);

          if (e instanceof HttpErrorResponse) {
            this.messageService.add({
              severity: 'error',
              summary: 'Falha',
              detail: 'Ocorreu um erro ao carregar os parâmetros',
              life: 3000,
            });
          }
        },
      });
  }
}
